// extracted by mini-css-extract-plugin
export default {"frame":"styles_frame__UuXc+"};